/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * The vulnerability backend that produced the finding.
 */
export enum VulnerabilitySource {
  Trustify = 'trustify',
  Quay = 'quay',
}
